import StateType from './state.type';

export default {
  loading: false,
  loadingVariation: false,
  attributes: [],
  total: 0,
} as StateType;
